import type { OrderStatus } from '../../types/order';

export const NEW_ORDER_VIEW_STATUSES: OrderStatus[] = ['NEW_INQUIRY'];

export const IN_PROGRESS_ORDER_VIEW_STATUSES: OrderStatus[] = [
  'QUOTE_SENT',
  'CONFIRMED',
  'IN_FULFILLMENT',
  'READY_FOR_DISPATCH',
  'IN_DELIVERY',
  'PARTIALLY_DELIVERED',
];

export const orderStatusFilterMatchesView = (
  currentStatuses: string[],
  viewStatuses: OrderStatus[]
) =>
  currentStatuses.length === viewStatuses.length &&
  viewStatuses.every((status) => currentStatuses.includes(status));

export const countOrdersByStatuses = <T extends { status?: string | null }>(
  orders: T[],
  statuses: OrderStatus[]
) => orders.filter((order) => order.status && statuses.includes(order.status as OrderStatus)).length;
